module.exports = __webpack_public_path__ + "fonts_/iconfont.4175e88.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/iconfont.woff?t=1573030555456
// module id = 20
// module chunks = 0